var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhitelabelAddToCart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12691",
    "data-name": "Group 12691",
    transform: "translate(-226 -404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4803",
    "data-name": "Group 4803",
    transform: "translate(23702 9980)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_217",
    "data-name": "Path 217",
    transform: "translate(-23476 -9576)",
    fill: "#fff8e4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.99999618530273 98 C 43.5191535949707 98 37.23323822021484 96.73117065429688 31.31685256958008 94.22873687744141 C 25.60128211975098 91.81125640869141 20.46775245666504 88.35001373291016 16.05886840820312 83.94112396240234 C 11.64999580383301 79.53224182128906 8.188738822937012 74.39872741699219 5.771253108978271 68.68315124511719 C 3.268824815750122 62.76675415039062 1.999996185302734 56.48083877563477 1.999996185302734 49.99999618530273 C 1.999996185302734 43.5191535949707 3.268824815750122 37.23323822021484 5.771253108978271 31.31685256958008 C 8.188738822937012 25.60128211975098 11.64999580383301 20.46775245666504 16.05886840820312 16.05886840820312 C 20.46775245666504 11.64999580383301 25.60128211975098 8.188738822937012 31.31685256958008 5.771253108978271 C 37.23323822021484 3.268824815750122 43.5191535949707 1.999996185302734 49.99999618530273 1.999996185302734 C 56.48083877563477 1.999996185302734 62.76675415039062 3.268824815750122 68.68315124511719 5.771253108978271 C 74.39872741699219 8.188738822937012 79.53224182128906 11.64999580383301 83.94112396240234 16.05886840820312 C 88.35001373291016 20.46775245666504 91.81125640869141 25.60128211975098 94.22873687744141 31.31685256958008 C 96.73117065429688 37.23323822021484 98 43.5191535949707 98 49.99999618530273 C 98 56.48083877563477 96.73117065429688 62.76675415039062 94.22873687744141 68.68315124511719 C 91.81125640869141 74.39872741699219 88.35001373291016 79.53224182128906 83.94112396240234 83.94112396240234 C 79.53224182128906 88.35001373291016 74.39872741699219 91.81125640869141 68.68315124511719 94.22873687744141 C 62.76675415039062 96.73117065429688 56.48083877563477 98 49.99999618530273 98 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 49.99999618530273 3.999992370605469 C 43.78828048706055 3.999992370605469 37.76448059082031 5.215682983398438 32.095947265625 7.613265991210938 C 26.61878204345703 9.929916381835938 21.69892883300781 13.24723052978516 17.47307586669922 17.47307586669922 C 13.24723052978516 21.69892883300781 9.929916381835938 26.61878204345703 7.613265991210938 32.095947265625 C 5.215682983398438 37.76448059082031 3.999992370605469 43.78828048706055 3.999992370605469 49.99999618530273 C 3.999992370605469 56.21171188354492 5.215682983398438 62.23551177978516 7.613265991210938 67.90404510498047 C 9.929916381835938 73.38121032714844 13.24723052978516 78.30106353759766 17.47307586669922 82.52691650390625 C 21.69892883300781 86.75276184082031 26.61878204345703 90.07008361816406 32.095947265625 92.38672637939453 C 37.76448059082031 94.78430938720703 43.78828048706055 96 49.99999618530273 96 C 56.21171188354492 96 62.23551177978516 94.78430938720703 67.90404510498047 92.38672637939453 C 73.38121032714844 90.07008361816406 78.30106353759766 86.75276184082031 82.52691650390625 82.52691650390625 C 86.75276184082031 78.30106353759766 90.07008361816406 73.38121032714844 92.38672637939453 67.90404510498047 C 94.78430938720703 62.23551177978516 96 56.21171188354492 96 49.99999618530273 C 96 43.78828048706055 94.78430938720703 37.76448059082031 92.38672637939453 32.095947265625 C 90.07008361816406 26.61878204345703 86.75276184082031 21.69892883300781 82.52691650390625 17.47307586669922 C 78.30106353759766 13.24723052978516 73.38121032714844 9.929916381835938 67.90404510498047 7.613265991210938 C 62.23551177978516 5.215682983398438 56.21171188354492 3.999992370605469 49.99999618530273 3.999992370605469 M 49.99999618530273 -7.62939453125e-06 C 77.61422729492188 -7.62939453125e-06 100 22.38576507568359 100 49.99999618530273 C 100 77.61422729492188 77.61422729492188 100 49.99999618530273 100 C 22.38576507568359 100 -7.62939453125e-06 77.61422729492188 -7.62939453125e-06 49.99999618530273 C -7.62939453125e-06 22.38576507568359 22.38576507568359 -7.62939453125e-06 49.99999618530273 -7.62939453125e-06 Z",
    stroke: "none",
    fill: "#ffc629"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11380",
    "data-name": "Group 11380",
    transform: "translate(1345.699 -53.473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5568",
    "data-name": "Path 5568",
    d: "M-1057.186,498c1.578-2.546,6.752-3.634,8.654-5.536a4.666,4.666,0,0,0-.22-6.537,4.667,4.667,0,0,0-6.537-.22c-1.9,1.9-2.99,7.077-5.536,8.654s-8.46-2.493-8.46-2.493l-5.082,5.082,14.658,14.658,5.082-5.082S-1058.763,500.55-1057.186,498Z",
    transform: "translate(1.145 0)",
    fill: "none",
    stroke: "#1d1d1d",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5569",
    "data-name": "Path 5569",
    d: "M-1060.724,509.461l-7.788,7.787-11.909-11.909,7.788-7.787",
    transform: "translate(0.786 0.774)",
    fill: "none",
    stroke: "#1d1d1d",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_679",
    "data-name": "Line 679",
    y1: 3.665,
    x2: 3.665,
    transform: "translate(-1071.003 511.08)",
    fill: "none",
    stroke: "#1d1d1d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_680",
    "data-name": "Line 680",
    y1: 3.207,
    x2: 3.207,
    transform: "translate(-1076.816 505.726)",
    fill: "none",
    stroke: "#1d1d1d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_681",
    "data-name": "Line 681",
    y1: 2.291,
    x2: 2.291,
    transform: "translate(-1073.537 509.92)",
    fill: "none",
    stroke: "#1d1d1d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_682",
    "data-name": "Line 682",
    x1: 1.832,
    y2: 1.832,
    transform: "translate(-1051.65 488.204)",
    fill: "none",
    stroke: "#1d1d1d",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_683",
    "data-name": "Line 683",
    x1: 5.424,
    y2: 5.424,
    transform: "translate(-1088.383 509.437)",
    fill: "none",
    stroke: "#1d1d1d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_684",
    "data-name": "Line 684",
    x1: 5.518,
    y2: 5.518,
    transform: "translate(-1076.567 521.347)",
    fill: "none",
    stroke: "#1d1d1d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_685",
    "data-name": "Line 685",
    x1: 2.428,
    y2: 2.428,
    transform: "translate(-1081.417 513.407)",
    fill: "none",
    stroke: "#1d1d1d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_686",
    "data-name": "Line 686",
    x1: 3.996,
    y2: 3.996,
    transform: "translate(-1079.016 517.377)",
    fill: "none",
    stroke: "#1d1d1d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5570",
    "data-name": "Path 5570",
    d: "M-1077.017,495.581h-15.622a1.06,1.06,0,0,0-1.059,1.059v31.776a1.06,1.06,0,0,0,1.059,1.059h37.072a1.059,1.059,0,0,0,1.06-1.059V512.881",
    transform: "translate(0 0.658)",
    fill: "none",
    stroke: "#1d1d1d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_687",
    "data-name": "Line 687",
    x2: 9.401,
    transform: "translate(-1091.58 502.594)",
    fill: "none",
    stroke: "#1d1d1d",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_688",
    "data-name": "Line 688",
    x2: 2.118,
    transform: "translate(-1090.521 499.416)",
    fill: "none",
    stroke: "#1d1d1d",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_689",
    "data-name": "Line 689",
    x2: 2.118,
    transform: "translate(-1087.344 499.416)",
    fill: "none",
    stroke: "#1d1d1d",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitelabelAddToCart);
export default __webpack_public_path__ + "static/media/whitelabel_addToCart.998814e2b00399246de5b71dab43d63d.svg";
export { ForwardRef as ReactComponent };